import { serviceRoles } from "config/access";
import { QUIZ_CATEGORIES } from "constants/routes";
import { checkAccess } from "helpers/auth";
import QuizCategoriesPage from "./container/QuizCategoriesPage";

export default function getSettingsRoute(requireAuthFunctions) {
  const { account, cpfm } = serviceRoles;
  const requireAuth = {
    [account.name]: [account.roles.superadmin],
    [cpfm.name]: [cpfm.roles.admin],
  };
  return {
    path: QUIZ_CATEGORIES,
    onEnter: () => checkAccess(requireAuth, requireAuthFunctions),
    withSidebar: true,
    withAppBar: true,
    component: QuizCategoriesPage,
  };
}
